// React
import React, {Component} from 'react';
// Components
import Alert from "@material-ui/lab/Alert";
// Styles
import './styles.scss';

export default class AlertInfo extends Component {

    render() {
        const {text, className} = this.props;
        return (
            <div className={className ?? ""}>
                <Alert severity="info">
                    <span dangerouslySetInnerHTML={{__html: text}}></span>
                </Alert>
            </div>
        );
    }
}